export const stripPlusOne = (phoneNum: string) => {
  const match = phoneNum.match(/^\+1(.*)$/);

  if (match) {
    return match[1];
  } else {
    return phoneNum;
  }
}
